module.exports = __webpack_public_path__ + "assets/img/aboutUs.c200bc7f.jpg";